import { CommonModule, NgFor } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

import { FilterPanelComponent } from '../../filter-panel.component';

@Component({
  selector: 'app-event-logs-filter',
  standalone: true,
  imports: [CommonModule, NgFor, TranslateModule, FilterPanelComponent],
  templateUrl: './event-logs-filter.component.html',
  styleUrl: './event-logs-filter.component.scss',
})
export class EventLogsFilterComponent implements OnInit {
  @Input() numberOfResults: number = 0;
  @Input() selectedEventLogNumbers: number[] = [];
  // The meter model's own names for the logs; an empty entry shows the default name.
  @Input() eventLogLabels: string[] = [];

  @Output() applied = new EventEmitter<number[]>();

  readonly eventLogNumbers = [1, 2, 3, 4, 5, 6];

  draftEventLogNumbers: number[] = [];

  get activeFilterCount(): number {
    return this.selectedEventLogNumbers.length;
  }

  ngOnInit(): void {
    this.reset();
  }

  toggle(item: number): void {
    this.draftEventLogNumbers = this.draftEventLogNumbers.includes(item)
      ? this.draftEventLogNumbers.filter((i) => i !== item)
      : [...this.draftEventLogNumbers, item];
  }

  onApply(): void {
    this.applied.emit(this.draftEventLogNumbers);
  }

  onCancel(): void {
    this.reset();
  }

  private reset(): void {
    this.draftEventLogNumbers = [...this.selectedEventLogNumbers];
  }
}
